import { useNavigate } from '@tanstack/react-router';
import { useGT } from 'gt-react';
import type { TaskPageResponse } from '@erp/rpc';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  tabChangeSearch,
  tabKeyFromValue,
  type TaskPageTab,
} from './taskPageTabs';

/**
 * One tab per task type. Switching navigates to `?tab=<key>` alone, so the
 * new tab's queue starts from the page's default filters.
 */
export function TaskPageTabStrip({
  page,
  tabs,
  activeKey,
}: {
  page: TaskPageResponse;
  tabs: readonly TaskPageTab[];
  activeKey: string;
}) {
  const gt = useGT();
  const navigate = useNavigate();
  return (
    <Tabs
      value={activeKey}
      onValueChange={(value) => {
        const key = tabKeyFromValue(tabs, value);
        if (!key) return;
        void navigate({
          to: '/pages/$taskPageId',
          params: { taskPageId: page.id },
          search: tabChangeSearch(key),
        });
      }}
    >
      <TabsList
        className="w-fit max-w-full overflow-x-auto"
        aria-label={gt('Task types', {
          context:
            'accessible label for the tab strip switching between the task types a task page shows',
        })}
      >
        {tabs.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {tab.title}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
